// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"804b8fd0","117":"a04def9e","787":"d4899d03"}[chunkId] + ".chunk.js";
};